<template>
  <div class="journey-viewer">
    <div v-if="inited">
      <div v-for="(item, index) in journeyDay" :key="index" class="journey-single-day">
        <div class="journey-day-header">
          <div class="day-title justify-content-between" v-if="showHeaderInfo">
            <div class="d-flex align-items-center">
              <p class="fs-capation-12">Day</p>
              <p class="fs-h5">{{index + 1}}</p>
              <p class="fs-14px" v-if="index === 0">{{__dayStr(index)}}</p>
            </div>

            <div class="d-flex align-items-center">
              <p class="fs-capation-12 desc">行走</p>
              <div class="directions-walk">
                <span class="fs-title-18" v-if="totalCostMinutes[index] >= 60">{{parseInt(totalCostMinutes[index] / 60)}}</span>
                <span class="fs-small-11" v-if="totalCostMinutes[index] >= 60">h</span>
                <span class="fs-title-18">{{parseInt(totalCostMinutes[index] % 60)}}</span>
                <span class="fs-small-11">mins</span>
              </div>
            </div>

<!--            <p class="weather-msg fs-14px" v-text="__weatherMsg(index)"></p>-->
          </div>
          <div class="day-title" v-else>
            <p class="fs-capation-12">Day</p>
            <p class="fs-h5">{{index + 1}}</p>
            <p class="desc fs-capation-12">
              <span>預計走 </span>
              <span v-if="parseInt(totalCostMinutes[index] / 60) > 0">
                <span>{{parseInt(totalCostMinutes[index] / 60)}}</span>
              <span> 小時</span>
              </span>
              <span v-if="parseInt(totalCostMinutes[index] % 60) > 0">
                <span>{{parseInt(totalCostMinutes[index] % 60)}}</span>
                <span> 分鐘</span>
              </span>
              <span>，於 </span>
              <span v-text="arrivalTime[index]"></span>
              <span> 抵達。</span>
            </p>

          </div>
          <hr/>
        </div>
        <journey-day :climbRate="journey.climbRateArray[index]" :climb-unit="climbUnit" :journey-item="item" :show-header-info="showHeaderInfo" :show-start-time-select="showStartTimeSelect" :show-timestamp="true" :show-opt-btn="showOptBtn" :show-weather="showWeather && (__weatherType(index) === 0)" @optclick="__milestoneOptClicked(index, $event)" @start-time-changed="__milestoneStartTimeChanged(index, $event)" @calcTotalCostMinutes="(data) => calcTotalCostMinutes(index, data)" @updateClimbRate="(data) => updateClimbRate(index, data)"></journey-day>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import JourneyDay from './JourneyDay.vue';

export default {
  name: 'JourneyViewer',
  components: {
    JourneyDay
  },
  data() {
    return {
      journeyDay: [],
      inited: false,

      arrivalTime: [],
      totalCostMinutes: [],
    }
  },
  props: {
    journey: {
      type: Object,
      required: true,
    },
    climbUnit: {
      type: Number,
      required: false,
      default: -1,
    },
    showStartTimeSelect: {
      type: Boolean,
      required: false,
      default: true,
    },
    showOptBtn: {
      type: Boolean,
      required: false,
      default: true,
    },
    showWeather: {
      type: Boolean,
      required: false,
      default: true,
    },
    showHeaderInfo: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  created() {
    // 避免prop尚未進入導致的undefined, __refresh移至watch中執行
  },
  async mounted() {
    if(this.journey) {
      await this.__refresh();
      this.inited = true;
    }
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
    journey: {
      deep: true, // 監測對象内部屬性的變化
      handler(newPropValue) {
        // 監聽prop的變化
        if (newPropValue !== undefined) {
          this.__refresh();
        }
      },
    },
  },
  methods: {
    __milestoneOptClicked(index, subIndex) {
      let realIndex = 0;
      if (index > 0) {
        realIndex = this.journey.journeySplitIndexs[index - 1];
      }
      realIndex += subIndex;
      // console.log(`${realIndex} clicked.`);
      this.$emit('optclick', realIndex);
    },
    __milestoneStartTimeChanged(index, startTime) {
      this.$emit('start-time-changed', {
        index,
        startTime,
      });
    },
    __splitJourney() {
      this.journeyDay.splice(0, this.journeyDay.length);
      if (this.journey.journeySplitIndexs.length === 0) {
        this.journeyDay.push(this.journey.journey);
      } else {
        let temp = [];
        let ind = 0;
        for (let i=0;i<this.journey.journey.length;i++) {
          if (i === this.journey.journeySplitIndexs[ind]) {
            const tempEnd = {... this.journey.journey[i]};
            tempEnd.endTimestamp = tempEnd.startTimestamp;
            tempEnd.endTime = moment(tempEnd.endTimestamp).format('YYYY-MM-DD HH:mm');
            temp.push(tempEnd);

            ind += 1;
            this.journeyDay.push(temp);
            temp = [];

            const tempStart = {... this.journey.journey[i]};
            tempStart.startTimestamp = tempStart.endTimestamp;
            tempStart.startTime = moment(tempStart.startTimestamp).format('YYYY-MM-DD HH:mm');
            temp.push(tempStart);
          } else {
            temp.push(this.journey.journey[i]);
          }
        }
        this.journeyDay.push(temp);
      }
    },
    __dayStr(index) {
      const d = moment(this.journey.startDate);
      // console.log(moment.months());
      d.add(index, 'days');
      return d.format('MM/DD(dd)');
    },
    __weatherType(index) {
      const d = moment(this.journey.startDate);
      d.hour(0).minute(0).second(0).millisecond(0);
      d.add(index, 'days');
      const m = moment().hour(0).minute(0).second(0).millisecond(0);
      if (d.isBefore(m)) {
        return -1;
      }
      m.add(7, 'days');
      if (d.isBefore(m)) {
        return 0;
      }
      return 1;
    },
    __weatherMsg() {
    // __weatherMsg(index) {
      // 2023/05/03 氣候來源不準，暫時關閉
      // const type = this.__weatherType(index);
      // if (type === -1) {
      //   return '*已無氣候資訊';
      // } else if (type === 1) {
      //   const d = moment(this.journey.startDate);
      //   d.add(index, 'days');
      //   d.subtract(6, 'days');
      //   return `*將於${d.format('MM/DD')}顯示天氣預報`;
      // }
      return '';
    },
    __refresh() {
      try {
        this.__splitJourney();
      } catch(e) {
        console.error(e);
      }
    },
    calcTotalCostMinutes(index, data) {
      console.log(data);
      console.log(index);
      this.$set(this.arrivalTime, index, data.arrivalTime);
      this.$set(this.totalCostMinutes, index, data.totalCostMinutes);
    },
    updateClimbRate(index, data) {
      const newClimbRateArray = [...this.journey.climbRateArray];
      newClimbRateArray[index] = data;
      console.log(newClimbRateArray)
      this.$emit('updateClimbRateArray', newClimbRateArray);
    },
  }

}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
  ::v-deep .journey-single-day:first-child .journey-row:first-child a.milestone-opt, ::v-deep .journey-single-day:last-child .journey-row:last-child a.milestone-opt {
    display: none;
  }

  p {
    margin: 0;
    &.desc {
      color: $color-bk-tp-50;
    }
  }

  .journey-viewer {

  }

  .journey-single-day {
    padding: 1rem 0;
    margin-bottom: 0rem;
    background-color: #fff;
  }

  .journey-day-header {
    /* margin-bottom: .5rem; */
  }

  .journey-day-header hr {
    margin: .5rem 0;
    border-top: solid 1px #000;
  }

  .day-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    .desc {
      color: $color-bk-tp-50;
    }
  }

  .directions-walk {
    display: flex;
    align-items: end;
    gap: .125rem;
    * {
      flex-shrink: 0;
    }
    .fs-small-11 {
      transform: scale(0.9166666667) translateY(-2.9px);
    }
  }

  .day-title p {
    padding-right: 1rem;
  }

  .day-title p.big-text {
    font-size: 1.2em;
    font-weight: 1000;
  }

  .day-title p.weather-msg {
    flex: 1 1;
    text-align: right;
    font-size: .6em;
    color: #0005;
    padding-right: 0;

  }

  .day-feature>p {
    font-size: .7rem;
  }

  .day-feature .big-text {
    font-size: 1.1rem;
    font-weight: 1000;
  }

  .day-start-time-select>select {
    margin-left: 1rem;
    border: none;
  }

  @media (min-width: 992px) {
    .journey-single-day {
      padding: 1rem 0;
    }

    .journey-day-header {
      padding: 0 2rem;
    }
  }
</style>
